<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb" style="padding-top: 20px">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <el-divider></el-divider>
    <div class="col-md-12">
      <h4 slot="header" class="card-title text-purple">
        {{ $t("app.modules.account_statements.name") }}
      </h4>
      <n-button @click.native="getPDF()" type="primary" round>
        <i slot="label" class="now-ui-icons files_paper"></i>
        {{ $t("app.buttons.pdf") }}
      </n-button>
      <div class="col-md-12">
        <div class="row">
          <el-table stripe style="width: 100%" :data="account">
            <el-table-column
              prop="idClienteSAP"
              :label="this.$t('app.modules.customers.client_code_SAP')"
              :min-width="280"
              sortable
            >
            </el-table-column>

            <el-table-column
              prop="facturaFiscal"
              :label="
                this.$t('app.modules.account_statements.headers.fiscal_bill')
              "
              :min-width="280"
              sortable
            >
            </el-table-column>

            <el-table-column
              prop="facturaComercial"
              :label="
                this.$t(
                  'app.modules.account_statements.headers.commercial_bill'
                )
              "
              :min-width="280"
              sortable
            >
            </el-table-column>

            <el-table-column
              prop="fechaFaturacion"
              :label="
                this.$t('app.modules.account_statements.headers.bill_date')
              "
              :min-width="280"
              sortable
            >
              <template slot-scope="scope">
                {{ parseDateMoment(scope.row.fechaFaturacion) }}
              </template>
            </el-table-column>

            <el-table-column
              :label="
                this.$t(
                  'app.modules.account_statements.headers.starting_amount'
                )
              "
              :min-width="280"
              sortable
            >
              <template slot-scope="scope">
                {{ number_format(scope.row.movimientos[0], 2) }}
              </template>
            </el-table-column>

            <el-table-column
              :label="
                this.$t('app.modules.account_statements.headers.payments')
              "
              :min-width="280"
              sortable
            >
              <template slot-scope="scope">
                <div
                  v-for="(mov, index) in scope.row.movimientos"
                  v-if="index > 0"
                >
                  <label style="font-size: 14px; color: #606266">{{
                    number_format(mov, 2)
                  }}</label
                  ><br />
                </div>
              </template>
            </el-table-column>

            <el-table-column
              :label="this.$t('app.modules.account_statements.headers.balance')"
              :min-width="280"
              sortable
            >
              <template slot-scope="scope">
                {{ number_format(subtotal(scope.row.movimientos)) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="moneda"
              :label="this.$t('app.modules.account_statements.headers.money')"
              :min-width="280"
              sortable
            >
            </el-table-column>

            <el-table-column
              prop="terminosPago"
              :label="
                this.$t('app.modules.account_statements.headers.payment_terms')
              "
              :min-width="280"
              sortable
            >
            </el-table-column>

            <el-table-column
              :label="
                this.$t('app.modules.account_statements.headers.expire_date')
              "
              :min-width="280"
              sortable
            >
              <template slot-scope="scope">
                {{
                  getFechaVencimiento(
                    scope.row.fechaFacturaBase,
                    scope.row.terminosPago
                  )
                }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- Print Block -->
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1800"
          filename="estado_cuenta"
          :pdf-quality="1"
          :manual-pagination="false"
          pdf-format="letter"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          @startPagination="startPagination()"
          @hasDownloaded="hasDownloaded($event)"
          ref="html2Pdf"
        >
          <section slot="pdf-content" style="padding: 30px 10px 120px 30px">
            <div style="width: 100%">
              <div style="width: 10%; display: inline-block">
                <img
                  src="img/logo1.png"
                  alt=""
                  style="width: 60px; height: 60px"
                />
              </div>
              <div style="width: 90%; display: inline-block; text-align: left">
                <h3>RESIRENE</h3>
              </div>
            </div>

            <div style="width: 100%; height: 30px"></div>

            <div style="width: 100%">
              <div
                style="width: 50%; display: inline-block; vertical-align: top"
              >
                {{ this.direccion.calle }}
                {{ this.direccion.numInterior }}<br />
                {{ this.direccion.colonia
                }}<br v-if="!!this.direccion.colonia" />
                C.P.: {{ this.direccion.codigoPostal }}
              </div>
              <div style="width: 50%; display: inline-block">
                <table
                  style="width: 100%; border: 1px solid black; font-size: 12px"
                >
                  <thead>
                    <tr>
                      <th colspan="2" style="text-align: center">
                        {{
                          this.$t(
                            "app.modules.account_statements.headers.list_items"
                          )
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="border: 1px solid black; padding: 2px">
                        {{ this.$t("app.general.date") }}
                      </td>
                      <td style="border: 1px solid black; padding: 2px">
                        {{ this.parseDatetime(this.currDate) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid black; padding: 2px">
                        {{
                          this.$t(
                            "app.modules.account_statements.headers.responsible"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid black; padding: 2px">
                        {{ this.$store.state.user.nombre }}
                      </td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid black; padding: 2px">
                        {{
                          this.$t(
                            "app.modules.account_statements.headers.phone"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid black; padding: 2px">
                        {{ this.direccion.telefono1 }}
                      </td>
                    </tr>
                    <tr>
                      <td style="border: 1px solid black; padding: 2px">
                        {{
                          this.$t(
                            "app.modules.account_statements.headers.account"
                          )
                        }}
                      </td>
                      <td style="border: 1px solid black; padding: 2px">
                        {{ this.direccion.idDireccionSAP }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div style="width: 100%; height: 60px"></div>

            <div style="width: 100%">
              <table
                style="width: 100%; border: 1px solid black; font-size: 12px"
              >
                <thead>
                  <tr>
                    <th style="border: 1px solid black; padding: 2px">
                      {{ this.$t("app.modules.customers.client_code_SAP") }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.fiscal_bill"
                        )
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.commercial_bill"
                        )
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.bill_date"
                        )
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t("app.modules.account_statements.headers.money")
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.starting_amount"
                        )
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.payments"
                        )
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.balance"
                        )
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.payment_terms"
                        )
                      }}
                    </th>
                    <th style="border: 1px solid black; padding: 2px">
                      {{
                        this.$t(
                          "app.modules.account_statements.headers.expire_date"
                        )
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="acc in tableData" :key="acc.idClienteSAP">
                    <td style="border: 1px solid black; padding: 2px">
                      {{ acc.idClienteSAP }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{ acc.facturaFiscal }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{ acc.facturaComercial }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{ parseDateMoment(acc.fechaFaturacion) }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{ acc.moneda }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{ number_format(acc.movimientos[0], 2) }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      <div
                        v-for="(mov, index) in acc.movimientos"
                        :key="index"
                        v-if="index > 0"
                      >
                        <label>{{ number_format(mov, 2) }}</label
                        ><br />
                      </div>
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{ number_format(subtotal(acc.movimientos), 2) }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{ acc.terminosPago }}
                    </td>
                    <td style="border: 1px solid black; padding: 2px">
                      {{
                        getFechaVencimiento(
                          acc.fechaFacturaBase,
                          acc.terminosPago
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        border: 1px solid black;
                        padding: 2px;
                        text-align: center;
                      "
                      colspan="10"
                    >
                      <b
                        >{{
                          $t("app.modules.account_statements.headers.total")
                        }}:
                      </b>
                      {{ number_format(grantotal(), 2) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </vue-html2pdf>
      </div>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            {{ $t("app.pagination.showing") }} {{ from + 1 }}
            {{ $t("app.pagination.of") }} {{ to }}
            {{ $t("app.pagination.of") }} {{ total }}
            {{ $t("app.pagination.records") }}
          </p>
        </div>

        <n-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        >
        </n-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";
import { number_format, getResponse } from "@/util/utilities";
import { Direccion } from "@/models/pedidos/Direccion";
export default {
  components: {
    VueHtml2pdf,
  },
  data() {
    return {
      tableData: [],
      currDate: new Date(),
      item: {},
      account: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      direccion: new Direccion(),
    };
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      // return this.account.reduce((acc, item) => acc + item.monto, 0);
      return this.account.length;
    },
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html:
        '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });

    await this.getAccount();
    await this.getDireccionFiscal();

    this.$swal.close();
  },
  methods: {
    number_format,
    async getAccount() {
      var payload = {
        id: this.$store.state.user.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("EstadoCuenta/processEstadosCuenta"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.account = response.body.estadosCuenta;
              this.tableData = response.body.estadosCuenta;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async savePDF() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      var payload = {
        id: this.item.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: 1,
        direccionFiscal: this.$t(
          "app.modules.account_statements.headers.fiscal_address"
        ),
        idClienteSAP: this.$t(
          "app.modules.account_statements.headers.client_id"
        ),
        facturaFiscal: this.$t(
          "app.modules.account_statements.headers.fiscal_bill"
        ),
        facturaComercial: this.$t(
          "app.modules.account_statements.headers.commercial_bill"
        ),
        fechaFaturacion: this.$t(
          "app.modules.account_statements.headers.bill_date"
        ),
        moneda: this.$t("app.modules.account_statements.headers.money"),
        monto: this.$t("app.modules.account_statements.headers.amount"),
        terminosPago: this.$t(
          "app.modules.account_statements.headers.payment_terms"
        ),
        fechaVencimiento: this.$t(
          "app.modules.account_statements.headers.expire_date"
        ),
      };

      await this.$http
        .post(route("EstadoCuenta/getEstadosCuentaClientePDF"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.report_url = response.body.ruta;
              console.log(this.report_url);
              window.open(this.report_url, "_blank");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});

      this.$swal.close();
    },
    getPDF() {
      // this.$router.push({ path: 'estado_cuenta_cliente_pdf', params: this.item })
      this.$refs.html2Pdf.generatePdf();
    },
    parseDatetime(dt) {
      console.log(dt);
      var year = dt.getFullYear();
      var month = (dt.getMonth() + 1).toString().padStart(2, "0");
      var day = dt.getDate().toString().padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    parseDateMoment(dt) {
      return moment(dt).format("YYYY/MM/DD");
    },
    getFechaVencimiento(fechaBase, terminos) {
      return moment(fechaBase).add(terminos, "days").format("YYYY/MM/DD");
    },
    async getDireccionFiscal() {
      var payload = {
        idClienteSAP: this.$store.state.user.idClienteSAP.toString(),
      };

      await this.$http
        .post(route("EstadoCuenta/getDireccionFiscalByClienteSAP"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.direccion = response.body.direcciones[0];
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    subtotal(movs) {
      return movs.reduce((acc, item) => acc + item, 0);
    },
    grantotal() {
      return this.tableData.reduce(
        (acc, item) => acc + this.subtotal(item.movimientos),
        0
      );
    },
    startPagination() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });
    },
    hasDownloaded($event) {
      this.$swal.close();
    },
  },
};
</script>

<style scoped>
</style>
